import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import PurchaseConfirmation from '../../components/PurchaseConfirmation';
import { useParams } from 'react-router-dom';
import { fetchReservationRequest } from '../../actions';

const PurchaseConfirmationContainer = () => {
  const { reservationId } = useParams();
  const dispatch = useDispatch();

  const { isLoading, reservation, error } = useSelector(state => ({
    logoUrl: state.personalization.data?.logoUrl,
    car: state.personalization.data || {},
    isLoading: state.purchase.isLoading,
    reservation: state.purchase.data,
    error: state.purchase.error,
  }));

  useEffect(() => {
    dispatch(fetchReservationRequest(reservationId));
  }, [dispatch, reservationId]);

  return (
    <PurchaseConfirmation
      error={error}
      isLoading={isLoading}
      reservation={reservation}
      reservationId={reservationId}
    />
  );
};

export default PurchaseConfirmationContainer;
